export default "__VITE_ASSET__BW4x3w$R__"